import ExtensionsTable from "../../views/pages/extensions/view";
import DidsTable from "../../views/pages/phone-numbers/view";
import IVRSTable from "../../views/pages/virtual-receptionist/view";
import CallGroupsTable from "../../views/pages/call-groups/view";
import QueuesTable from "../../views/pages/call-queues/view";
import FeatureCodesTable from "../../views/pages/feature-codes/view";
import VoicemailsTable from "../../views/pages/voicemails/view";
import DevicesTable from "../../views/pages/devices/view";
import FaxesTable from "../../views/pages/faxes/view";
import PagingGroupsTable from "../../views/pages/paging-groups/view";
import CallBlockingTable from "../../views/pages/call-blocking/view";
import ConferenceBridgesTable from "../../views/pages/conference-bridges/view";
import TimeOfDaysTable from "../../views/pages/time-of-days/view";
import ShortNumbersTable from "../../views/pages/short-numbers/view";
import DonotcallsTable from "../../views/pages/donotcalls/view";
import AnnouncementsTable from "../../views/pages/announcements/view";
import MusicOnHoldsTable from "../../views/pages/musiconholds/view";
import CustomDestinationsTable from "../../views/pages/custom-destinations/view";
import MediaFilesTable from "../../views/pages/mediafiles/view";
import ButtonLayoutsTable from "../../views/pages/buttonlayouts/view";
import CallCampaignsTable from "../../views/pages/call-campaigns/view";
import PhonebooksTable from "../../views/pages/phonebooks/view";
import PharmacyAgentsTable from "../../views/pages/pharmacy-agents/view";
import ParkinglotsTable from "../../views/pages/parkinglots/view.vue";

import layouts from "../../layout";

export default [
  {
    path: "/extensions",
    name: "extensions",
    component: ExtensionsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["extensions"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/phone-numbers",
    name: "phone-numbers",
    component: DidsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["phone-numbers"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/donotcalls",
    name: "donotcalls",
    component: DonotcallsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["donotcalls"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/campaigns",
    name: "campaigns",
    component: CallCampaignsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["campaigns"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/time-of-days",
    name: "time-of-days",
    component: TimeOfDaysTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["time-of-days"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/short-numbers",
    name: "short-numbers",
    component: ShortNumbersTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["short-numbers"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/virtual-receptionist",
    name: "virtual-receptionist",
    component: IVRSTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["virtual-receptionist, virtual receptionist"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/call-groups",
    name: "call-groups",
    component: CallGroupsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["call-groups"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/call-queues",
    name: "call-queues",
    component: QueuesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["call-queues"],
      roles: [1, 3, 7, 11, 12],
    },
  },
  {
    path: "/feature-codes",
    name: "feature-codes",
    component: FeatureCodesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["features", "feature codes"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/voicemails",
    name: "voicemails",
    component: VoicemailsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["voicemails"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/devices",
    name: "devices",
    component: DevicesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["devices"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/faxes",
    name: "faxes",
    component: FaxesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["faxes"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/paging-groups",
    name: "paging-groups",
    component: PagingGroupsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["paging groups"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/call-blocking",
    name: "call-blocking",
    component: CallBlockingTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["call-blocking"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/conference-bridges",
    name: "conference-bridges",
    component: ConferenceBridgesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["conference bridges"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/announcements",
    name: "announcements",
    component: AnnouncementsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["announcements"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/musiconholds",
    name: "musiconholds",
    component: MusicOnHoldsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["music on holds"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/media-files",
    name: "mediafiles",
    component: MediaFilesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["mediafiles"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/custom-destinations",
    name: "custom-destinations",
    component: CustomDestinationsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["custom destinations"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/button-layouts",
    name: "button-layouts",
    component: ButtonLayoutsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["button layouts"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/phonebooks",
    name: "phonebooks",
    component: PhonebooksTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["phonebooks"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/pharmacy-agents",
    name: "pharmacy-agents",
    component: PharmacyAgentsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["pharmacy-agents"],
      roles: [1, 3, 11, 12],
    },
  },
  {
    path: "/parkinglots",
    name: "parkinglots",
    component: ParkinglotsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["parkinglots"],
      roles: [1, 3, 11, 12],
    },
  },
];
